export const financialYearWithCode = [
  "2015-21",
  "2015-21",
  "2015-21",
  "2015-21",
  "2015-21",
  "2015-21",
  "2015-21",
  "2021-22",
  "2022-23",
  "2023-24",
  "2025-26",
  "2026-27",
  "2027-28",
  "2028-29",
  "2029-30",
  "2030-31",
];
export const financialYearCode = [
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
];
export const monthWithCode = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
];
